var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-popover',{attrs:{"placement":"bottom-start","trigger":"hover"}},[_c('div',[_c('div',{domProps:{"innerHTML":_vm._s(_vm.content)}})]),_c('div',{staticClass:"inline",attrs:{"slot":"reference"},on:{"click":_vm.handleOpen},slot:"reference"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }